import { NgModule } from '@angular/core'
import { RequestInterceptorModule } from './request-interceptor/request-interceptor.module'
import { CacheInterceptorModule } from './cache-interceptor/cache-interceptor.module'

@NgModule({
  declarations: [],
  imports: [RequestInterceptorModule, CacheInterceptorModule],
  exports: [RequestInterceptorModule, CacheInterceptorModule],
})
export class InterceptorsModule {}
